module.exports = __webpack_public_path__ + "static/media/SF_nn_engl_primaerlogo_troendelag_neg.efc26691.pdf";